<template>
  <section>
    <LoadingContainer v-if="isLoading" class="box--mini" />

    <div v-else>
      <!-- <WelcomeBox
        class="header-gap"
        v-if="!hasBillboard && (!hasUserSubscriptionAccess && !subscription.is_pending)"
      /> -->

      <WelcomeBox20 
        class="header-gap" 
        v-if="!hasBillboard && (!hasUserSubscriptionAccess && !subscription.is_pending)"
      />

      <Billboard
        v-else-if="hasBillboard"
        :items="billboard"
      />
  </div>
    
  </section>
</template>

<script>
import { mapGetters } from "vuex"
import WelcomeBox20 from "@/components/home/WelcomeBox20"
import Billboard from "@/components/billboard/Billboard"
import LoadingContainer from "@/components/layout/LoadingContainer"
import { getBillboard } from "@/api/billboard.api.js"

export default {
  components: {
    WelcomeBox20,
    Billboard,
    LoadingContainer,
  },

  data: () => ({
    isLoading: false,

    billboard: []
  }),

  computed: {
    ...mapGetters("user", ["isLogged", "hasUserSubscriptionAccess"]),

    ...mapGetters("subscription", ["subscription"]),

    hasBillboard () {
      return this.billboard.length
    }
  },

  async mounted(){
    this.billboard = await getBillboard()
  }
}
</script>